import { definePreset } from '@primeng/themes';
import Aura from '@primeuix/themes/aura';

const PascomTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fef2f5',
      100: '#fde6eb',
      200: '#fcccd7',
      300: '#fa99b3',
      400: '#f7668f',
      500: '#d20134',
      600: '#b8012e',
      700: '#9e0128',
      800: '#840122',
      900: '#6a011c',
      950: '#500115'
    }
  }
});

export default PascomTheme;
